import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  constructor(private readonly httpClient: HttpClient) {}

  public get<T>(apiUrl: string, params?: HttpParams): Observable<T> {
    return this.httpClient.get<T>(this.buildUrl(apiUrl), {
      withCredentials: true,
      params,
    });
  }

  public getFile<T>(apiUrl: string, params?: HttpParams): Observable<T> {
    return this.httpClient.get<T>(this.buildUrl(apiUrl), {
      withCredentials: true,
      params,
      responseType: "blob" as "json",
    });
  }

  public post<T, U>(payload: T, apiUrl: string): Observable<U> {
    return this.httpClient.post<U>(this.buildUrl(apiUrl), payload, {
      withCredentials: true,
    });
  }

  public put<T, U>(payload: T, apiUrl: string): Observable<U> {
    return this.httpClient.put<U>(this.buildUrl(apiUrl), payload, {
      withCredentials: true,
    });
  }

  public delete<T>(payload: T, apiUrl: string): Observable<unknown> {
    return this.httpClient.delete(this.buildUrl(apiUrl), {
      body: payload,
      withCredentials: true,
    });
  }

  public patch<T, U>(payload: T, apiUrl: string): Observable<U> {
    return this.httpClient.patch<U>(this.buildUrl(apiUrl), payload, {
      withCredentials: true,
    });
  }

  private buildUrl(apiUrl: string): string {
    return `${environment.url.bffBaseUrl}/${apiUrl}`;
  }
}
